import { html } from 'lit';
import { Settings } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-settings')
export class PdsIconSettings extends PdsIcon {
  @state()
  icon = Settings;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
